/**
 * DevBanner — shown when running on a dev-* deployment URL or localhost.
 * Suppressed by setting VITE_HIDE_DEV_BANNER=true in .env.
 * Always shows the app version + deployment timestamp at the bottom.
 */
import { useState, useEffect } from 'react';

export default function DevBanner() {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  const isDevHost =
    hostname.startsWith('dev-volleyball') ||
    hostname.startsWith('dev-throwball') ||
    hostname === 'localhost' ||
    hostname === '127.0.0.1';
  const hidden = import.meta.env.VITE_HIDE_DEV_BANNER === 'true';
  const version = import.meta.env.VITE_APP_VERSION || '—';
  const [deployedAt, setDeployedAt] = useState<string | null>(null);

  useEffect(() => {
    fetch('/deploy-info.json')
      .then(r => r.json())
      .then(d => {
        if (d.deployedAt) {
          const dt = new Date(d.deployedAt);
          const fmt = dt.toLocaleString(undefined, {
            month: 'short', day: 'numeric',
            hour: '2-digit', minute: '2-digit',
          });
          setDeployedAt(fmt);
        }
      })
      .catch(() => {});
  }, []);

  return (
    <>
      {isDevHost && !hidden && (
        <div
          style={{
            background: '#b45309',
            color: '#fff',
            textAlign: 'center',
            padding: '6px 16px',
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: '0.08em',
            zIndex: 99999,
            position: 'relative',
          }}
        >
          ⚠ DEV ENVIRONMENT — Do not score real matches here
        </div>
      )}

      {/* Version + deploy time — full-width bottom strip, never overlaps content */}
      <div
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          textAlign: 'center',
          fontSize: 9,
          color: 'rgba(155,155,155,0.45)',
          fontFamily: 'monospace',
          zIndex: 9998,
          pointerEvents: 'none',
          userSelect: 'none',
          padding: '2px 0 env(safe-area-inset-bottom, 2px)',
          letterSpacing: '0.04em',
        }}
      >
        v{version}{deployedAt ? ` · ${deployedAt}` : ''}
      </div>
    </>
  );
}
